import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { EmployeeBreakInServiceReportService } from './employeeBreakInServiceReport.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { OrderPipe } from 'ngx-order-pipe';

@Component({
    moduleId: module.id,
    templateUrl: 'employeeBreakInServiceReport.html',
    styleUrls: ['./employeeBreakInService.component.css']
})
export class EmployeeBreakInServiceReportComponent implements OnInit {
    dataLoaded: boolean;
    selectedYear: string[];
    selectedControlGroup: string[];
    selectedWeekStarting: string;
    selectedWeekEnding: string;
    order: string = 'key';
    reverse: boolean = false;
    downloadPdfInProgress: boolean = false;
    downloadExcelInProgress: boolean = false;
    headerData = [
        { name: "Controlled Group", key: "ControlGroup" },
        { name: "Employee Name", key: "FirstName"},
        { name: "SSN", key: "SSN" },
        { name: "Service Status", key: "ServiceStatus" },
        { name: "Week Starting", key: "WeekStarting"},
        { name: "Week Ending", key: "WeekEnding" },
        { name: "Week Count", key: "WeekCount" },
        { name: "Union Status", key: "UnionType" },
        { name: "Union Name", key: "UnionName" }
    ]
    Years: Array<string>;
    ControlGroups: Array<string>;
    public loading = false;
    public rows: Array<any> = [];
    public page: number = 1;
    public itemsPerPage: number = 10;
    public maxSize: number = 5;
    public numPages: number = 1;
    public length: number = 0;
    public lenghtofdata: any;
    title: string;
    selecttitle: any;
    optionsModel: number[];
    myOptionsYear: any[];
    myOptionsCG: any[];

    @ViewChild('topScroll') topScroll: ElementRef;
    @ViewChild('bottomScroll') bottomScroll: ElementRef;

    employeeBeakInService: Array<any> = [];
    errorMessage: string;
    userData: any;
    paginationData: any = {};
    reportData: any = [];
    searchValue: any;
    cgDropdownSettings = {
        singleSelection: false,
        text: 'Select Controlled Group',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        classes: 'myclass custom-class',
        badgeShowLimit: 3
    };
    selectedCgValues: any[];
    showfiltererror: boolean = false;
    downloadexcel: any;
    downloadpdf: any;
    selectedYearValues: any = [];
    yearDropdownSettings: any = {
        singleSelection: false,
        text: 'Select Year',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        classes: 'myclass custom-class',
        badgeShowLimit: 3
    };
    isfilterloaded: boolean = false;
    headername: string;
    constructor(private orderPipe: OrderPipe,private _employeeBreakInServiceReportService: EmployeeBreakInServiceReportService) {
        this.userData = JSON.parse(localStorage.getItem('token'));
        this.reportData = orderPipe.transform(this.headerData, 'key');
    }
    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse;
        }
        this.order = value;
    }

    ngOnInit(): void {

        if (localStorage.getItem('storedData')) {
            this.onloadData();
        }

        this.setFilterData();
        
        if (this.selectedWeekStarting === '') {
            this.selectedWeekStarting = '2016-12-30';
        }
        if (this.selectedWeekEnding === '') {
            this.selectedWeekEnding = '2017-12-30';
        }
    }

    onloadData(): void {
        const ssnData = JSON.parse(localStorage.getItem('storedData'));
        this.loading = true;
        this._employeeBreakInServiceReportService.getSSnData(ssnData).subscribe(empbreakinservice => {
            this.loading = false;
            this.dataLoaded = true;
            this.reportData = empbreakinservice;
        },
            error => this.errorMessage = <any>error);
    }
    reset(): void {
        this.selectedYear = [];
        this.dataLoaded = false;
        this.searchValue = '';
        this.showfiltererror = false;
        this.selectedYearValues = [];
        if(this.userData.principal.roles[0] !== 'User' || this.userData.principal.controlGroups.length > 1){
            this.selectedControlGroup = [];
            this.selectedCgValues = [];
        }
    }
    getFilterValues(): any {
        let year = this.selectedYear;
        if (year === undefined) {
            year = [];
            year[0] = '\'\'';
            this.selectedYear = [];
        }
        if (year !== undefined && year.length <= 0) {
            year[0] = '\'\'';
            this.selectedYear = [];
        }
        let cg = this.selectedControlGroup;
        if (cg === undefined) {
            cg = [];
            cg[0] = '\'\'';
            this.selectedControlGroup = [];

        }
        if (cg !== undefined && cg.length <= 0) {
            cg[0] = '\'\'';
            this.selectedControlGroup = [];
        }
        let ws = this.selectedWeekStarting;
        if (ws === '' || ws === undefined) {
            ws = "''";
        }
        let we = this.selectedWeekEnding;
        if (we === '' || we === undefined) {
            we = "''";
        }
        let filterCriteria: any = {
            selectedYear: year.join(':'),
            selectedControlGroup: cg.join(':'),
            selectedWeekStart: ws,
            selectedWeekEnding: we
        }
        return filterCriteria;
    }

    employeeBreakInServiceReports(page = 1, searchKey = (this.searchValue || '')): void {
        this.loading = true;
        this.dataLoaded = true;
        this.isfilterloaded = true;
        let filterCriteria = {
            taxYear: this.selectedYear || [],
            controlGroup: this.selectedControlGroup || [],
            searchKey,
            pagination: {
                pageNo: page,
                pageSize: 10
            }
        }
        if (filterCriteria.controlGroup.length === 0) {
            this.showfiltererror = true;
            this.loading = false;
            this.dataLoaded = false;
            this.isfilterloaded = false;
        } else {
            this.showfiltererror = false;
            this._employeeBreakInServiceReportService.getEmployeeBreakInServiceReportData(filterCriteria).subscribe((data: any) => {
                this.isfilterloaded = false;
                this.reportData = data.breakInReportDataVO;
                this.paginationData = data.pagination;
                this.loading = false;
            },
                error => this.errorMessage = <any>error);
        }

    }
    downloadPdf(): void {
        this.downloadpdf = true;
        let filterCriteria = this.getFilterValues();
        this._employeeBreakInServiceReportService.downloadPDFReport(filterCriteria).subscribe((data: any) => {
            this.downloadpdf = false;
        }, (err: any) => (this.downloadpdf = false));
    }

    downloadExcel(): void {
        this.downloadexcel = true;
        let filterCriteria = this.getFilterValues();
        this.showfiltererror = false;
        this._employeeBreakInServiceReportService.downloadExcelReport(filterCriteria).subscribe((data: any) => {
            this.downloadexcel = false
        }, (err: any) => (this.downloadexcel = false));
    }

    ngOnDestroy() {
        localStorage.removeItem('storedData')
    }

    Search(): void {
        this.reportData = [];
        this.paginationData = {};
        this.employeeBreakInServiceReports(1, this.searchValue);
    }

    onChangeTable(page: any): any {
        this.employeeBreakInServiceReports(page.page, this.searchValue)
    }

    searchTable(searchValue: any) {
        this.employeeBreakInServiceReports()
    }
    onChangeControlledGroup() {
        this.selectedControlGroup = this.selectedCgValues ? this.selectedCgValues.map((item: any) => item.itemName) : [];
    }
    onChangeYear() {
        this.selectedYear = this.selectedYearValues ? this.selectedYearValues.map((item: any) => item.itemName) : [];
    }
    setFilterData(){
        this.myOptionsYear = [];
        this.myOptionsCG = [];
        this._employeeBreakInServiceReportService.getReportData().subscribe(data => {
            this.myOptionsYear = data.WorkYear.map((element:any) => {return {id:element,itemName:element}});
            this.selectedWeekStarting = data.WeekStarting;
            this.selectedWeekEnding = data.WeekEnding;

            if(this.userData.principal.roles[0] == 'User'){
                if(this.userData.principal.controlGroups.length == 1){
                    this.cgDropdownSettings['disabled'] = true;
                    this.cgDropdownSettings['singleSelection'] = true;
                    this.cgDropdownSettings = Object.assign({}, this.cgDropdownSettings);
                    this.selectedCgValues = [{id:this.userData.principal.controlGroups[0], itemName:this.userData.principal.controlGroups[0]}]
                    this.selectedControlGroup = [this.userData.principal.controlGroups[0]]
                }else{
                    this.myOptionsCG = this.userData.principal.controlGroups.filter((val:any) => data.ControlGroup.includes(val)).map((element:any) => {return {id:element,itemName:element}});
                }
            }else{
                this.myOptionsCG = data.ControlGroup.map((element:any) => {return {id:element,itemName:element}});
            }
        },
            error => this.errorMessage = <any>error);
    }
}



// WEBPACK FOOTER //
// ./src/app/EmployeeBreakInServiceReport/employeeBreakInService.component.ts